import React, { useEffect, useState } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { downloadCSV, fetchDataCallOnInitialLoad } from "../../../common_nextgen/utils/UtilFunctions";

const useDiscountPatientPayTable = () => {
  const { axios_helper_no_header } = useAxios();

  const [data, setData] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const statusKey = "hiddenRecordIndicator";

  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [isHideConfirmationModalOpen, setIsHideConfirmationModalOpen] =
    useState(false);
  const [hideSelectedOption, setHideSelectedOption] = useState("no");
  const [hideFlag, setHideFlag] = useState(false);
  const [lookupType, setLookupType] = useState("");
  const [selectParams, setSelectParams] = useState([]);
  const [selectMode, setSelectMode] = useState(false);

  const toast = useToast();
  const location = useLocation();
  const {
    DISCOUNT_PATIENT_PAY_TABLE_ADD,
    DISCOUNT_PATIENT_PAY_TABLE_EDIT,
    DISCOUNT_PATIENT_PAY_TABLE_DISPLAY,
    COPY_DISCOUNT_PATIENT_PAY_TABLE,
    PRESCRIBER_NETWORKS,
    PHARMACY_NETWORKS,
  } = ROUTE_PATHS;

  const screen_title = "Discount Patient Pay Table";
  const [screenNumber, setScreenNumber] = useState(selectMode ? "RCPHN993" : "RCDP3001");

  const stateVal = location.state ?? [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  const {
    selectedPatients = [],
    previousScreen = "",
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      dp3DiscountTableId: "",
      hiddenRecordIndicator: "Active",
    },
  } = currentState;

  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [paramsData, setParamsData] = useState(initialParamsData);
  const selectedSchedulesData = selectedRows.length ? selectedRows : [rowData];
  const lastScheduleName =
    selectedSchedulesData[selectedSchedulesData.length - 1]?.dp3DiscountTableId;
  const updatedParamsData = {
    ...paramsData,
    dp3DiscountTableId: lastScheduleName,
  };

  const formFields = [
    {
      fieldLabel: "DP3 Discount Table ID",
      name: "dp3DiscountTableId",
      label: "Table",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Hidden Record IndicatorValid Values",
      name: "hiddenRecordIndicator",
      label: "Status",
      type: "dropdown",
      fieldNature: "editable",
      value: "",
      maxLength: 1,
    },
  ];

  const leftButtons = selectMode ? [{
    button_label: "Back",
    button_handeler: () => {
      if (lookupType === "external") {
        const message = { type: "hideModal" };
        window.parent.postMessage(message, "*");
      }
    },
    button_key: "F12",
  }] : [];

  const dropdownOptions = [
    { field_label: "Hidden Record Indicator", condition: "Valid Values" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };
  const ctaButtons = [
    ...(!selectMode && [{
      button_label: "Add Discount Patient Pay Table",
      button_handeler: () => {
        navigateToPage(DISCOUNT_PATIENT_PAY_TABLE_ADD, [
          { paramsData },
          {
            previousScreen: location.pathname,
          },
        ]);
      },
      button_key: "F6",
    }]) || [],
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  const menuOptions = selectMode
    ? [
        {
          label: "Select",
          icon: <span className="material-icons">add</span>,
          command: async () => {
            try {
              const paramDataMap = new Map();
              selectParams.forEach(key => {
                if (rowData.hasOwnProperty(key["target"])) {
                  paramDataMap.set(key["source"], rowData[key["target"]]);
                }
              });
              const paramData = Object.fromEntries(paramDataMap);

              if (lookupType === "external") {
                const message = {
                  type: "responseData",
                  data: paramData,
                };
                window.parent.postMessage(message, "*");
              }
            } catch (error) {
              console.error(error);
            }
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            if (lookupType === "external") {
              const message = {
                type: "navigateData",
                data: { ...rowData },
                target: "DISCOUNT_PATIENT_PAY_TABLE_READ_ONLY",
                schedulesDataKey: "selectedDiscount",
              };
              console.log("display message", message);
              window.parent?.postMessage(message, "*");
            }
          },
        },
        {
          label: "Prescriber Networks",
          icon: <span className="material-icons">group</span>,
          command: () => {
            if (lookupType === "external") {
              const message = {
                type: "navigateData",
                data: { ...rowData },
                target: "PRESCRIBER_NETWORKS",
                schedulesDataKey: "selectedSchedules",
              };
              console.log("display message", message);
              window.parent?.postMessage(message, "*");
            }
          },
        },
        {
          label: "Pharmacy Networks",
          icon: <span className="material-icons">local_pharmacy</span>,
          command: () => {

             if (lookupType === "external") {
              const message = {
                type: "navigateData",
                data: { ...rowData },
                target: "PHARMACY_NETWORKS",
                schedulesDataKey: "selectedSchedules",
              };
              console.log("display message", message);
              window.parent?.postMessage(message, "*");
            }
          },
        },
      ]
    : [
        {
          label: "Edit",
          icon: <span className="material-icons">edit</span>,
          command: () => {
            navigateToPage(DISCOUNT_PATIENT_PAY_TABLE_EDIT, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedDiscount: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Copy",
          icon: <span className="material-icons">content_copy</span>,
          command: () => {
            navigateToPage(COPY_DISCOUNT_PATIENT_PAY_TABLE, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedPriceSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Delete",
          icon: <span className="material-icons">delete</span>,
          command: () => {
            openConfirmationModal();
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            navigateToPage(DISCOUNT_PATIENT_PAY_TABLE_DISPLAY, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedDiscount: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Prescriber Networks",
          icon: <span className="material-icons">group</span>,
          command: () => {
            navigateToPage(PRESCRIBER_NETWORKS, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Pharmacy Networks",
          icon: <span className="material-icons">local_pharmacy</span>,
          command: () => {
            navigateToPage(PHARMACY_NETWORKS, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
      ];

  if (rowData["hiddenRecordIndicator"] === "Active" && !selectMode) {
    menuOptions.push({
      label: "Hide",
      icon: <span className="material-icons">visibility_off</span>,
      command: () => {
        openHideConfirmationModal();
      },
    });
  }

  const columnDef = [
    {
      header: "Table",
      field: "dp3DiscountTableId",
    },
    {
      header: "Description",
      field: "dp3DiscountTableDesc",
    },
    {
      header: "Status",
      field: "hiddenRecordIndicator",
    },
  ];

  const parmKey = "dp3DiscountTableId";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/DP3DiscountPatPayTbl`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchDataCallOnInitialLoad(fetchData, lookupType);
  }, [paramsData, rows, currentPage, hideFlag, lookupType]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const openHideConfirmationModal = () => {
    setIsHideConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const closeHideConfirmationModal = () => {
    console.log(hideSelectedOption);
    setIsHideConfirmationModalOpen(false);
    setHideSelectedOption("no");
  };

  const hidePatientPayTable = () => {
    if (hideSelectedOption === "yes") {
      const params = {
        dp3DiscountTableId: rowData[parmKey],
        screenNumber: screenNumber,
      };
      axios_helper_no_header(
        "PUT",
        "api/DP3DiscountPatPayTbl/hideDiscountTable",
        null,
        params
      )
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);

          // if (currentPage > 0) {
          //   setFirst(0);
          //   setCurrentPage(0);
          // } else {
          //   fetchData();
          // }
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          setHideFlag(!hideFlag);
          closeHideConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error hiding the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeHideConfirmationModal();
        });
    } else {
      closeHideConfirmationModal();
    }
  };

  const deleteDiscountPatientPayTable = () => {
    if (selectedOption === "yes") {
      const params = { dp3DiscountTableId: rowData.dp3DiscountTableId };
      axios_helper_no_header("DELETE", "api/DP3DiscountPatPayTbl", null, params)
        .then((response) => {
          const updatedItems = data.filter(
            (item) => item.dp3DiscountTableId !== rowData.dp3DiscountTableId
          );
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;

          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({ ...paramsData });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/DP3DiscountPatPayTbl/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const handleMessage = (event) => {
		const { type, data } = event.data;
		console.log("iframe load", type, data);
		if (type === "initData") {
			const { selectMode, data: paramData } = data;
			console.log("external data", paramData, selectMode);
			setLookupType("external");
			setSelectParams(paramData.params);
			setParamsData(prev => ({...prev, ...paramData.paramsData}));
			setSelectMode(selectMode);

      if (paramData.screenNumber) setScreenNumber(paramData.screenNumber);
		}
		console.log("message", event.data);
	};

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  return {
    screenNumber,
    selectMode,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    leftButtons,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteDiscountPatientPayTable,
    hidePatientPayTable,
    isHideConfirmationModalOpen,
    closeHideConfirmationModal,
    setHideSelectedOption,
    setSelectedOption,
    disabledDropdown: selectMode ? {hiddenRecordIndicator: true} : {}
  };
};

export default useDiscountPatientPayTable;